import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { ShipmentSpecialFreightMapData } from '../../models/shipment-special-freight-tracking-map.model';
import { ShipmentSpecialFreightManagerEndpoint } from '../../constants';
import { SpecialFreightIdView } from '../../../../models';

@Injectable({
  providedIn: 'root',
})
export class ShipmentSpecialFreightTrackingMapService {
  constructor(private http: WrapperHttpService) {}

  getShipmentLoadTrackingMapData(identifier: SpecialFreightIdView): Observable<ShipmentSpecialFreightMapData> {
    return this.http
      .withLoading()
      .get<ShipmentSpecialFreightMapData>(
        `${API_URL}${ShipmentSpecialFreightManagerEndpoint.Base}${
          ShipmentSpecialFreightManagerEndpoint.SpecialFreights
        }${ShipmentSpecialFreightManagerEndpoint.Map}?${getQueryStringFromObject(identifier)}`,
      );
  }
}
